import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Кастомные имена размеров шрифта из блока `@theme` в ds-theme.css.
 *
 * tailwind-merge знает только стоковую шкалу (xs…9xl). Любое своё имя он относит к группе
 * цвета текста, поэтому `text-control` рядом с `text-primary-foreground` молча исчезает —
 * а `text-control` это база всех кнопок. Список держит синхронным с темой
 * `tools/ci/ds-font-sizes.test.mjs`.
 */
export const DS_FONT_SIZES = [
  'fine',
  'control',
  'catalog-caption',
  'catalog-subheading',
  'catalog-body',
  'catalog-title',
  'catalog-display',
  'auth-title',
  'project-title',
  'empty-state',
  'navtab',
] as const;

/** twMerge, знающий шкалу размеров дизайн-системы. Единственная точка входа для `hlm()`. */
export const dsTwMerge = extendTailwindMerge({
  extend: { theme: { text: [...DS_FONT_SIZES] } },
});
